import { useEffect, useState } from 'react';
import sessionsService from '../../services/sessions';
import sessionsVisualizeService from '../../services/sessionsVisualize';
import { Video } from '../../services/sessionModels';

export default function useSessionVideo(videoId?: string | null) {
  const [video, setVideo] = useState<Video | null>(null);

  useEffect(() => {
    if (!videoId) return;
    let cancelled = false;
    sessionsService
      .getVideo(videoId)
      .then((result) => !cancelled && setVideo(result))
      .catch(() => !cancelled && setVideo(null));
    return () => {
      cancelled = true;
    };
  }, [videoId]);

  return video;
}

export function useSnapshot(videoId?: string | null) {
  const [snapshot, setSnapshot] = useState<string | null>(null);

  useEffect(() => {
    if (!videoId) return;
    let cancelled = false;
    sessionsVisualizeService
      .getSnapshot(videoId)
      .then((result) => !cancelled && setSnapshot(result || null))
      .catch(() => !cancelled && setSnapshot(null));
    return () => {
      cancelled = true;
    };
  }, [videoId]);

  return snapshot;
}
